import { DeviceMode, isComplexElement, isNodeV2, isSlotElement } from '@vedalib/editor'
import * as R from 'ramda'

import { getElement, getParentNode } from 'components/Editor/EditorContext/selectors/block'
import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { setProjectNavigation, updateBlock } from 'services/Store/Project/actions'
import {
  addNode,
  cloneNode,
  moveCoordinates,
  moveGridArea,
} from 'services/Store/Project/mutators/node'
import {
  getBlock,
  getDeviceMode,
  getSelectedNodeIds,
  mergeNodeStyle,
} from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'
import { t } from 'services/Translation'

import { isGrid, isAbsolute } from '../guards'

export const onClone = (event?: KeyboardEvent) => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const selectedNodes = getSelectedNodeIds(state)
  const parent = getParentNode(selectedNodes[0], block)
  const parentElement = block && getElement(block, parent?.elementId || '')
  const parentStyle = mergeNodeStyle(parent?.style || {}, DeviceMode.desktop)
  const isDesktop = getDeviceMode(state) === DeviceMode.desktop

  if (block && parent && selectedNodes.length && !isSlotElement(parentElement)) {
    event?.preventDefault()
    if (!isDesktop) {
      return notify({
        type: NotificationType.info,
        message: t('editorV2.notifyStructureChangesRestricted'),
      })
    }
    const nodes = selectedNodes.map((id) => block.schema.nodes[id]).filter(isNodeV2)
    const cloned = nodes.map((node) => cloneNode(block, node.id))
    const element = isNodeV2(parent) && parent.elementId ? block?.elements[parent.elementId] : null

    const index =
      Math.max(
        ...nodes.map((item) =>
          isComplexElement(element)
            ? element.value.items.map((i) => i.value).indexOf(item.id)
            : parent.children.indexOf(item.id),
        ),
      ) + 1
    const cbs = cloned.map(({ root, elements, nodes }) =>
      R.compose(
        isGrid(parentStyle)
          ? moveGridArea(root.id, DeviceMode.desktop, ['down'])
          : R.identity<Block>,
        isAbsolute(parentStyle)
          ? moveCoordinates(root.id, DeviceMode.desktop, ['down', 'right'], 10)
          : R.identity<Block>,
        addNode(parent.id, root, { elements, nodes }, { index }),
      ),
    ) as [(block: Block) => Block]
    dispatch(updateBlock({ id: block.uuid, value: R.compose(...cbs)(block) }))
    dispatch(setProjectNavigation({ nodeIds: cloned.map(({ root }) => root.id) }))
  }
}
